import Vue from 'vue'
import Vuex from 'vuex'
import {
  pricing,
  subscription,
  invoice,
  support,
  instance,
  region,
  currency,
  cancellationReason,
  visitor,
  upload,
  connections,
} from '@/store/modules'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {},
  mutations: {},
  actions: {},
  modules: {
    pricing,
    subscription,
    invoice,
    support,
    instance,
    region,
    currency,
    cancellationReason,
    visitor,
    upload,
    connections,
  },
})
